import { CustomBranding, RequestParams } from '@commutifi-fe/interfaces';
import { EnterpriseProps } from '@commutifi/models/Enterprises';
import { apiCall, dashboardApiServer } from '../../index';
import endpoints from './endpoints';
const apiDashboardServer = apiCall(dashboardApiServer);
export interface IdentityProviderProps {
  enable: boolean;
  id: string;
  type: 'OAUTH2' | 'CBRE';
  name: string;
  providerName: string;
  subdomain: string;
  customBranding?: CustomBranding;
}
interface SubdomainData {
  data: {
    identityProvider: IdentityProviderProps;
    customBranding?: CustomBranding;
    enterprise?: EnterpriseProps;
  };
}
export const fetchSubdomainData = (subdomain: string, queryParams: RequestParams = {}): Promise<SubdomainData> => apiDashboardServer(endpoints.GET.SubdomainData.route(subdomain), {
  method: 'get',
  params: queryParams,
  // A 401 here is a domain answer ("no legacy identity-provider record" — the
  // endpoint's catch rewrites NotFoundError to 401), not an auth failure. The
  // flag keeps the interceptor's refresh→retry→forceLocalLogout chain away
  // from it, which would otherwise tear down a freshly-hydrated SSO session;
  // useSubdomain maps the 401 to "no legacy IdP" instead.
  skipAuthRefresh: true
});